import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
    <path d="M21.0781 0H38V12.6667H21.0781V0ZM21.0781 38V16.9219H38V38H21.0781ZM0 38V25.3333H16.9219V38H0ZM0 21.0781V0H16.9219V21.0781H0Z" fill="currentColor" />
  </svg>
);
